<h1 mat-dialog-title *ngIf="!isLoading" xmlns="http://www.w3.org/1999/html" class="clone-event__title">Clone Event</h1>
<div id="spinnerContainer" *ngIf="isLoading">
  <mat-dialog-content>
    <mat-spinner id="spinner" [diameter]="100" [color]="'accent'"></mat-spinner>
  </mat-dialog-content>
</div>
<div *ngIf="!isLoading">
  <mat-dialog-content [formGroup]="formGroup">
    <p class="clone-event__header-text">This form will create a copy of this event with the exception of the event dates
     and times.  This will assist with creating similar events or scheduling the same event on multiple days.</p>

    <fieldset class="clone-event__form-section">
      <legend class="clone-event__form-section-title">New Clone Date and Time</legend>
      <mat-error class="clone-event__form_field_padding" *ngIf="showDateError()">Start time cannot be after end time</mat-error>
      <div class="clone-event__horizontal-fields">
        <mat-form-field>
          <input matInput
                 name="startDate"
                 formControlName="startDate"
                 [matDatepicker]="startDate"
                 [min]="startDateMin"
                 placeholder="Select New Start Date *"
                 (dateChange)="eventDateChange('input', $event)"/>
          <mat-datepicker-toggle matSuffix [for]="startDate"></mat-datepicker-toggle>
          <mat-datepicker #startDate></mat-datepicker>

        </mat-form-field>

        <div class="clone-event__time-header">Select New Start Time:</div>
        <mat-form-field>
          <mat-select placeholder="Hour" formControlName="startHour">
            <mat-option value="{{hour}}" *ngFor="let hour of eventHours">{{hour}}</mat-option>
          </mat-select>
        </mat-form-field>
        <div class="clone-event__time-colon">:</div>
        <mat-form-field>
          <mat-select placeholder="Minute" formControlName="startMin">
            <mat-option value="{{min}}" *ngFor="let min of eventMinutes">{{min}}</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field>
          <mat-select placeholder="AM/PM" formControlName="startAMPM">
            <mat-option value="{{ampm}}" *ngFor="let ampm of eventAMPM">{{ampm}}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="clone-event__horizontal-fields">
        <mat-form-field>
          <input
            name="endDate"
            formControlName="endDate"
            matInput [matDatepicker]="endPicker"
            [min]="endDateMin"
            placeholder="Select New End Date *"
            (dateChange)="eventDateChange('input', $event)"/>
          <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
          <mat-datepicker #endPicker></mat-datepicker>
        </mat-form-field>
        <div class="clone-event__time-header">Select New End Time:</div>
        <mat-form-field>
          <mat-select placeholder="Hour" formControlName="endHour">
            <mat-option value="{{hour}}" *ngFor="let hour of eventHours">{{hour}}</mat-option>
          </mat-select>
        </mat-form-field>
        <div class="clone-event__time-colon">:</div>
        <mat-form-field>
          <mat-select placeholder="Minute" formControlName="endMin">
            <mat-option value="{{min}}" *ngFor="let min of eventMinutes">{{min}}</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field>
          <mat-select placeholder="AM/PM" formControlName="endAMPM">
            <mat-option value="{{ampm}}" *ngFor="let ampm of eventAMPM">{{ampm}}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <mat-form-field class="clone-event__formItemSmallText">
        <mat-label>Time Zone *</mat-label>
        <mat-select formControlName="timezone">
          <mat-option value="{{tz}}" *ngFor="let tz of timeZones">{{tz}}</mat-option>
        </mat-select>
      </mat-form-field>
    </fieldset>
  </mat-dialog-content>

  <mat-dialog-actions>
    <p class="clone-event__header-text">Note: After clicking the CREATE CLONE EVENT button below, you will be taken
     to the new event details page where you can further edit the event if needed.</p>
    <button type="submit" [disabled]="!formGroup.valid" class="submit-button mat-raised-button clone-event__submit" (click)="save()">
      CREATE CLONE EVENT
    </button>
    <button id="cancelButton" class="mat-raised-button" (click)="cancel()">Cancel</button>
  </mat-dialog-actions>
</div>
